import React, {useEffect, useState} from 'react';
import GetProductList from "../../Products/GetProductList";
import FilterSelectOption from "../../../microComponents/tablePages/filter/FilterSelectOption";

const FilterProductList = () => {
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);

    useEffect(() => {

        GetProductList(setProductList, setProductListLoading)

    }, [])

    return (
        <FilterSelectOption data={{
            filterName: 'product', loading: productListLoading, placeholder: 'کالا', options: productList
        }}/>


    );
};

export default FilterProductList;